import styled from "@emotion/styled";
import { Typography } from "@mui/material";

import { useCustomTranslation } from "@/utils/useCustomTranslation";

import { InquiryResponseDtoStatus } from "@shared/generated/api/model";

export const InquiryStatus = ({
  status,
}: {
  status: InquiryResponseDtoStatus;
}) => {
  const { t } = useCustomTranslation();

  const INQUIRY_STATUS_TEXT: Record<string, string> = {
    [InquiryResponseDtoStatus.PENDING]: t("awaiting_answer"),
    [InquiryResponseDtoStatus.IN_PROGRESS]: t("awaiting_answer"),
    [InquiryResponseDtoStatus.ANSWERED]: t("answered"),
    [InquiryResponseDtoStatus.CLOSED]: t("answered"),
  };

  return (
    <StatusTypography status={status}>
      {INQUIRY_STATUS_TEXT[status]}
    </StatusTypography>
  );
};

const StatusTypography = styled(Typography)<{
  status: string;
}>`
  ${({ theme }) => theme.typography.body3.m};
  color: ${({ theme, status }) =>
    status === "PENDING"
      ? theme.colors.sub.blue.default
      : theme.colors.sub.green.default};
  text-decoration: none;
`;
